export const CLIENT_GEN_OTP = "CLIENT_GEN_OTP";
export const CLIENT_GEN_OTP_ERROR = "CLIENT_GEN_OTP_ERROR";
export const CLIENT_GEN_OTP_HIDE_ERROR = "CLIENT_GEN_OTP_HIDE_ERROR";
export const CLIENT_GEN_OTP_START_LOADER = "CLIENT_GEN_OTP_START_LOADER";
export const CLIENT_GEN_OTP_STOP_LOADER = "CLIENT_GEN_OTP_STOP_LOADER";
